<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-12-07 15:39:09
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Claim\ClaimType\components\editClaimTransactionType.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-03-04 18:07:23
-->
<template>
  <normalDialog
    width="700"
    @close="closeDialog"
    scrollable
    :title="
      iSEdited
        ? $t('label_essweb_ClaimType_form_dilog_editClaimTransTypeTitle')
        : $t('label_essweb_ClaimType_form_dilog_viewClaimTransTypeTitle')
    "
    :dialog="show"
  >
    <template v-slot:content>
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <inputTextFiledMultiLang
              :readonly="!iSEdited"
              maxlength="100"
              :filled="iSEdited"
              :bindData="Data.claim_transaction_type_name"
              :TrigerInit="show"
              @change="
                (valueArr) => {
                  Data.claim_transaction_type_name = valueArr;
                }
              "
              :label="
                $t('label_essweb_ClaimType_form_dilog_claimTransTypeNameLabel')
              "
              :rules="$GetRules(['_Require_Rules'], [null])"
            />
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <numberInputTextFiled
              maxlength="11"
              :filled="iSEdited"
              :label="$t('label_essweb_ClaimType_form_dilog_sequenceLabel')"
              :rules="
                $GetRules(['_Number_negative', '_Length_Rules'], [null, 11])
              "
              v-model="Data.sequence"
              :max="1000"
              :min="0"
              :placeholder="
                $t('label_essweb_ClaimType_form_dilog_sequenceLabel')
              "
            />
          </v-col>
          <v-col xs="12" sm="6" md="6" lg="6" cols="12">
            <v-sheet class="mrc_text_require text--secondary">{{
              $t("label_essweb_ClaimType_form_dilog_calculationMethodsLabel")
            }}</v-sheet>
            <v-autocomplete
              :filled="iSEdited"
              :readonly="!iSEdited"
              :items="CalculationMethods"
              :append-icon="iSEdited ? 'arrow_drop_down' : ''"
              item-text="view_fields"
              item-value="value_field"
              v-model="Data.calculation_method"
              single-line
              :rules="$GetRules(['_Require_Rules'], [null])"
              :placeholder="
                $t('label_essweb_ClaimType_form_dilog_calculationMethodsLabel')
              "
              dense
            >
              <template v-slot:no-data> <noContent /> </template
            ></v-autocomplete>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <normalInputTextFiled
              :filled="iSEdited"
              :readonly="!iSEdited"
              :rules="$GetRules(['_Require_Rules'], [null])"
              maxlength="100"
              :label="
                $t('label_essweb_ClaimType_form_dilog_claimTypeCodeLabel')
              "
              v-model="Data.claim_transaction_type_code"
              :placeholder="
                $t('label_essweb_ClaimType_form_dilog_claimTypeCodeLabel')
              "
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <inputTextFiledMultiLang
              :TrigerInit="show"
              :filled="iSEdited"
              maxlength="500"
              :readonly="!iSEdited"
              :bindData="Data.claim_transaction_type_description"
              @change="
                (valueArr) => {
                  Data.claim_transaction_type_description = valueArr;
                }
              "
              :label="$t('label_essweb_ClaimType_form_dialog_descriptionLabel')"
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="mrc_text_require text--secondary">{{
              $t("label_essweb_ClaimType_form_dilog_propertyGroupLabel")
            }}</v-sheet>
            <v-autocomplete
              :filled="iSEdited"
              :readonly="!iSEdited"
              :items="ClaimTransactionTypePorpertyGroup"
              item-text="claim_transaction_type_property_group_name"
              item-value="uuid"
              v-model="Data.claim_transaction_type_property_group_uuid"
              :append-icon="iSEdited ? 'arrow_drop_down' : ''"
              single-line
              :rules="$GetRules(['_Require_Rules'], [null])"
              :placeholder="
                $t('label_essweb_ClaimType_form_dilog_propertyGroupLabel')
              "
              dense
            >
              <template v-slot:no-data> <noContent /> </template
            ></v-autocomplete>
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="mrc_text_require text--secondary">{{
              $t(
                "label_essweb_ClaimType_form_dilog_overBalanceApprovalTemplateLabel"
              )
            }}</v-sheet>
            <v-autocomplete
              :items="approvalTemplates"
              item-text="flow_template_name"
              item-value="uuid"
              :filled="iSEdited"
              :readonly="!iSEdited"
              v-model="Data.over_balance_approval_flow_template_uuid"
              :append-icon="iSEdited ? 'arrow_drop_down' : ''"
              single-line
              :rules="$GetRules(['_Require_Rules'], [null])"
              :placeholder="
                $t(
                  'label_essweb_ClaimType_form_dilog_overBalanceApprovalTemplateLabel'
                )
              "
              dense
            >
              <template v-slot:no-data> <noContent /> </template
            ></v-autocomplete>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <template v-slot:actions>
      <CardActions
        v-if="iSEdited"
        saveBtn
        cancelBtn
        @save="onSave"
        @cancel="closeDialog"
      />
    </template>
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "editClaimTransactionType",
  props: {
    show: { default: false, type: [Boolean, Number] },
    iSEdited: { default: false, type: [Boolean, Number] },
    curUuid: { default: null, type: [String, Number] },
  },
  computed: {
    ...mapGetters(["companyLang"]),
    ClaimTransactionTypePorpertyGroup() {
      return this.$getSelectTrans(
        this.ClaimTransactionTypePorpertyGroupData,
        "claim_transaction_type_property_group_name"
      );
    },
    CalculationMethods() {
      return this.$getSelectTrans(this.CalculationMethodsData, "view_fields");
    },
    approvalTemplates() {
      return this.$getSelectTrans(
        this.approvalTemplateData,
        "flow_template_name"
      );
    },
  },
  data() {
    return {
      ClaimTransactionTypePorpertyGroupData: [],
      CalculationMethodsData: [],
      approvalTemplateData: [],
      Data: {
        uuid: null,
        claim_transaction_type_name: "",
        claim_transaction_type_description: "",
        claim_transaction_type_code: "",
        sequence: 1,
        calculation_method: "",
        claim_transaction_type_property_group_uuid: "",
        over_balance_approval_flow_template_uuid: "",
      },
    };
  },
  watch: {
    curUuid(val) {
      if (val) {
        this.getDetail();
      }
    },
    show(val) {
      if (!val) {
        this.Data = {
          uuid: null,
          claim_transaction_type_name: this.$getCommonLangKey(this.companyLang),
          claim_transaction_type_description: this.$getCommonLangKey(
            this.companyLang
          ),
          claim_transaction_type_code: "",
          sequence: 1,
          calculation_method: "",
          claim_transaction_type_property_group_uuid: "",
          over_balance_approval_flow_template_uuid: "",
        };
      }
    },
  },
  mounted() {
    this.Data.claim_transaction_type_description = this.$getCommonLangKey(
      this.companyLang
    );
    this.Data.claim_transaction_type_name = this.$getCommonLangKey(
      this.companyLang
    );
    this.getTransactionGroup();
    this.getCalMethods();
    this.getApprovalTemplates();
  },
  methods: {
    closeDialog: function () {
      this.$emit("close");
    },
    getCalMethods: function () {
      const that = this;
      this.$findPrompt({
        prompt_name: "ess_calculation_method_select",
      }).then((res) => {
        that.CalculationMethodsData = res.data;
      });
    },
    getTransactionGroup: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_clm_claim_transaction_type_property_group",
        url: "/claim-transaction-type-property-group/get-list/",
      }).then((res) => {
        that.ClaimTransactionTypePorpertyGroupData = res.data;
      });
    },
    getApprovalTemplates: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_templates",
        url: "/approval-template/get-approval-template-list/",
        data: {
          business_data_table_name: "ess_clm_claim_form_records", //bj 2021-07-05
        },
      }).then((res) => {
        that.approvalTemplateData = res.data;
      });
    },
    getDetail: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_clm_claim_transaction_type",
        url: "/claim-transaction-type/get-details/",
        data: { uuid: this.curUuid },
      }).then((res) => {
        res.data["claim_transaction_type_name_save"] =
          res.data.claim_transaction_type_name;
        res.data.claim_transaction_type_name = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.claim_transaction_type_name
        );
        res.data["claim_transaction_type_description_save"] =
          res.data.claim_transaction_type_description;
        res.data.claim_transaction_type_description =
          that.$transOnLineCommonLangKey(
            that.companyLang,
            res.data.claim_transaction_type_description
          );
        that.Data = res.data;
      });
    },
    onSave: function () {
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$emit("onSave", this.Data);
    },
  },
};
</script>